import { ExportFormat } from "../../api/exportsApi";

/**
 * The export formats the panel offers, in display order (AKL-1026).
 *
 * Kept out of `exportsApi.tsx` on purpose: the panel's tests mock that module wholesale,
 * so a runtime helper living there would be `undefined` under test.
 */
export const EXPORT_FORMATS: readonly ExportFormat[] = [
  "camtrap_dp",
  "wildlife_insights",
];

/** The server's own default, and what every export made before AKL-810 was. */
export const DEFAULT_EXPORT_FORMAT: ExportFormat = "camtrap_dp";

/** English translation keys for each format's name; render through `t()`. */
export const EXPORT_FORMAT_LABEL: Record<ExportFormat, string> = {
  camtrap_dp: "Camtrap DP",
  wildlife_insights: "Wildlife Insights bulk upload",
};

/**
 * Resolve a job's `format` to one the panel knows, defaulting to Camtrap DP.
 *
 * Lenient in the same way as the server's `parse_export_format`: a job persisted before
 * AKL-810 carries no format, and must still be shown as what it is. An exact match only —
 * the server always sends the canonical value.
 * @param value the format as the API returned it, if at all
 * @returns a known export format
 */
export const parseExportFormat = (
  value: string | null | undefined,
): ExportFormat =>
  (EXPORT_FORMATS as readonly string[]).includes(value ?? "")
    ? (value as ExportFormat)
    : DEFAULT_EXPORT_FORMAT;

/**
 * Whether a format takes the combined spreadsheet, AI prediction and MegaDetector
 * options. The Wildlife Insights writer ignores all three, so the panel hides them.
 * @param format the chosen format
 * @returns true for Camtrap DP only
 */
export const formatSupportsExtras = (format: ExportFormat): boolean =>
  format === "camtrap_dp";
